<h3 class="title">{{ _text.title }}</h3>

<app-chips-control
    (chipRemove)="emit_chipRemove($event)"
    [emptyText]="_text.audience_empty"
    [items]="chips$$()"
    [label]="_text.audience_label"
    [removable]="true"
    [removeTooltip]="_text.remove"
/>

<app-autocomplete-control
    (optionSelected)="emit_optionSelected($event)"
    [autofocus]="true"
    [clearOnSelect]="true"
    [control]="control_search"
    [fieldName_display]="optionField.display"
    [fieldName_value]="optionField.value"
    [label]="_text.search_label"
    [list]="options$$()"
    [optionTemplate]="audienceOption"
    [placeholder]="_text.search_placeholder"
/>
<ng-template #audienceOption let-option>
    <span class="option__name">{{ option.label }}</span>
    @if (option.detail) {
        <span class="option__detail">{{ option.detail }}</span>
    }
</ng-template>

<app-input-control
    [control]="control_subject"
    [label]="_text.subject_label"
    [required]="true"
/>

<app-rich-text-control
    [control]="control_body"
    [label]="_text.body_label"
    [minHeight]="'10em'"
/>

<app-slide-toggle-control [control]="control_acknowledge" [label]="_text.acknowledge_label" />

<!-- Zelfde action-knoppen als de footer (icoon + tooltip), zoals de chat-dialoog. -->
<app-buttons-row [align]="buttonsRowAlign.end">
    <app-button-action (btnClick)="emit_cancel()" [tooltip]="_text.cancel">
        <app-icon name="xmark" />
    </app-button-action>
    <app-button-action (btnClick)="emit_confirm()" [disabled]="!canConfirm$$()" [tooltip]="_text.confirm">
        <app-icon name="send-plane" />
    </app-button-action>
</app-buttons-row>
